//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'SearchLandingPage',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    HomeBenefits: () => import('@/components/home-page/HomeBenefits.vue'),
    CardSection: () => import('@/components/core/elements/CardSection.vue'),
    EmbedVideo: () => import('@motionelements/core/src/components/ui/embed/EmbedVideo.vue'),
    GoogleAds: () => import('@/components/core/GoogleAds.vue'),
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    heroSubTitle: {
      type: String,
      required: true,
    },
    heroImgUrl: {
      type: String,
      required: true,
    },
    heroImgDarkUrl: {
      type: String,
      required: true,
    },
    tryLinkUrl: {
      type: String,
      required: true,
    },
    waysToUseTitle: {
      type: String,
      required: true,
    },
    waysToUseSubTitle: {
      type: String,
    },
    waysToUse: {
      type: Array,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
    benefits: {
      type: Array,
      required: true,
    },
    testimonials: {
      type: Array,
      required: true,
    },
  },
};
